import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
/**
* @public
*/
const InsertAboveIcon = /* @__PURE__ */ forwardRef(function(props, ref) {
	return /* @__PURE__ */ jsx("svg", {
		"data-sanity-icon": "insert-above",
		width: "1em",
		height: "1em",
		viewBox: "0 0 25 25",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...props,
		ref,
		children: /* @__PURE__ */ jsx("path", {
			d: "M14.5 10.5556L10.5 10.5556M12.5 12.5L12.5 8.5M18.5 5.5L6.5 5.5M18.5 19.5L6.5 19.5L6.5 15.5L18.5 15.5L18.5 19.5Z",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeLinecap: "square",
			strokeLinejoin: "round"
		})
	});
});
export { InsertAboveIcon, InsertAboveIcon as default };

//# sourceMappingURL=InsertAbove.js.map